module.exports = __webpack_public_path__ + "img/museums.3479548b.svg";